const CONDENSED_MINIMUM_WIDTH = 767;
const CONDENSED_MAXIMUM_WIDTH = 1028;

const resetSidebarTheme = () => {
  document.body.removeAttribute('data-leftbar-theme');
  document.getElementById('side-main-logo')?.setAttribute('src', '/assets/logo.png');
  document.getElementById('side-sm-main-logo')?.setAttribute('src', '/assets/logo_sm.png');
};

export const activateLightSidebarTheme = () => {
  resetSidebarTheme();
  document.getElementById('side-main-logo')?.setAttribute('src', '/assets/logo-dark.png');
  document.getElementById('side-sm-main-logo')?.setAttribute('src', '/assets/logo_sm_dark.png');
  document.body.setAttribute('data-leftbar-theme', 'light');
};

export const activateDarkSidebarTheme = () => {
  resetSidebarTheme();
  document.body.setAttribute('data-leftbar-theme', 'dark');
};

const highlightActiveLinks = () => {
  const pageUrl = window.location.href.split(/[?#]/)[0];

  document.querySelectorAll('.side-nav a').forEach((link) => {
    if (link.href !== pageUrl) return;

    link.classList.add('active');
    link.closest('li')?.classList.add('mm-active');
  });
};

const enableScrollContainers = () => {
  document.querySelectorAll('.slimscroll').forEach((container) => {
    container.style.overflowY = 'auto';
  });
};

const adjustSidebarToWindowWidth = () => {
  const width = document.documentElement.clientWidth;

  if (width >= CONDENSED_MINIMUM_WIDTH && width <= CONDENSED_MAXIMUM_WIDTH) {
    document.body.setAttribute('data-leftbar-compact-mode', 'condensed');
  } else {
    document.body.removeAttribute('data-leftbar-compact-mode');
  }
};

let listenersBound = false;

const bindSidebarListeners = () => {
  if (listenersBound) return;
  listenersBound = true;

  window.addEventListener('resize', adjustSidebarToWindowWidth);

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('.button-menu-mobile');
    if (!button) return;

    event.preventDefault();
    document.body.classList.toggle('sidebar-enable');
  });
};

export const initSidebar = () => {
  highlightActiveLinks();
  enableScrollContainers();
  adjustSidebarToWindowWidth();
  bindSidebarListeners();
};
